module.exports = __webpack_public_path__ + "static/img/Eindhoven.7933b45.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Eindhoven.jpg
// module id = 3G2r
// module chunks = 1